import React, { useEffect, useState } from "react";
import MonthWiseRegReport from "./Reports/MonthWiseRegReport";
import RechargePlanStatusReport from "./Reports/RechargePlanStatusReport";
import Axios from '../../../services/AxiosInstance';

// import LastTransactionHistory from "./LastTransactionHistory";
import LastTransactionHistory from "./LastTransactionHistory";
import UseMessages from "./UseMessages";

const Home = () => {
    const [contactsData, setContactsData] = useState({ total_contacts: '', provides_contact: '', users_contacts: '' });
    const [requestPending, setRequestPending] = useState({ plan_request: 0, contacts_request: 0 });
    const [registrationBusiness, setregistrationBusiness] = useState({ total: 0, unapprove: 0, active: 0 });
    const getRequestData = () => {
        Axios.get('api/business/plan-contacts-pending-request')
            .then((res) => {
                setRequestPending({ plan_request: res.data.data.plan_request, contacts_request: res.data.data.contacts_request });
            })
            .catch((error) => {
                console.log(error);
            })
    }

    const getBusinessRegistration = () => {
        Axios.get('api/business/business-registration-reports')
            .then((res) => {
                setregistrationBusiness({ total: res.data.data.total, unapprove: res.data.data.unapprove, active: res.data.data.active })
            })
            .catch((error) => {
                console.log(error);
            })
    }

    useEffect(() => {
        getRequestData();
        getBusinessRegistration();
    }, [])
    const getReload = localStorage.getItem('relode')
    if (getReload === 'true') {
        window.location.reload(false);
        localStorage.setItem("relode", '');
    }


    return (
        <>
            <div className="content-page">
                <div className="content">

                    <div className="container-fluid">
                        <div className="row">
                            <div className="col-12">
                                <div className="page-title-box">

                                    <h4 className="page-title">Dashboard</h4>
                                </div>
                            </div>
                        </div>


                        <div className="row">
                            <div className="col-md-6 col-xl-3">
                                <div className="card-box tilebox-cont tilebox-one1">
                                    <i className="fe-box float-right"></i>
                                    <h5>Request Pending</h5>
                                    <h3>Buy Plan: {requestPending.plan_request}</h3>
                                    <h3>Buy Contacts: {requestPending.contacts_request}</h3>
                                    {/* <span className="badge badge-primary"> +11% </span> <span className="tilebox-txt ml-2 vertical-middle">From previous period</span> */}
                                </div>
                            </div>

                            <div className="col-md-6 col-xl-3">
                                <div className="card-box tilebox-cont tilebox-one2">
                                    <i className="fe-layers float-right"></i>
                                    <h5>Business Reg</h5>
                                    <h3>Total: {registrationBusiness.total}</h3>
                                    <h3>Active: {registrationBusiness.active}</h3>
                                    <h3>Unapprove: {registrationBusiness.unapprove}</h3>
                                    {/* <span className="badge badge-primary"> -29% </span> <span className="tilebox-txt ml-2 vertical-middle">From previous period</span> */}
                                </div>
                            </div>

                            <div className="col-md-6 col-xl-3">
                                <div className="card-box tilebox-cont tilebox-one3">
                                    <i className="fe-tag float-right"></i>
                                    <h5>Average Price</h5>
                                    <h3>$<span data-plugin="counterup">15.9</span></h3>
                                    <span className="badge badge-primary"> 0% </span> <span className="tilebox-txt ml-2 vertical-middle">From previous period</span>
                                </div>
                            </div>

                            <div className="col-md-6 col-xl-3">
                                <div className="card-box tilebox-cont tilebox-one4">
                                    <i className="fe-briefcase float-right"></i>
                                    <h5>Product Sold</h5>
                                    <h3 data-plugin="counterup">1,890</h3>
                                    <span className="badge badge-primary"> +89% </span> <span className="tilebox-txt ml-2 vertical-middle">Last year</span>
                                </div>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-lg-4">
                                <div className="card-box">
                                    <h4 className="header-title mb-3">Monthly bussiness Registration Reports</h4>
                                    <div className="inbox-item">
                                        <MonthWiseRegReport />
                                    </div>

                                </div>
                            </div>
                            <div className="col-lg-4">
                                <div className="card-box">
                                    <h4 className="header-title mb-3">Recharge Plan History</h4>
                                    <div className="inbox-item">
                                        <RechargePlanStatusReport />

                                    </div>
                                </div>
                            </div>

                        </div>

                        {/* ///////////////////////////////////////////////////////////////////////////////////////////////////////// */}
                        <div className="row">
                            {/* <div className="col-lg-4">
                                <div className="card-box">
                                    <h4 className="header-title mb-3">Messages</h4>

                                    <div className="inbox-widget slimscroll" >
                                        <a href="#">
                                            <div className="inbox-item">
                                                <div className="inbox-item-img"><img src="assets/images/users/avatar-1.jpg" className="rounded-circle bx-shadow-lg" alt="" /></div>
                                                <p className="inbox-item-author">Chadengle</p>
                                                <p className="inbox-item-text">Hey! there I'm available...</p>
                                                <p className="inbox-item-date">13:40 PM</p>
                                            </div>
                                        </a>
                                        <a href="#">
                                            <div className="inbox-item">
                                                <div className="inbox-item-img"><img src="assets/images/users/avatar-2.jpg" className="rounded-circle bx-shadow-lg" alt="" /></div>
                                                <p className="inbox-item-author">Tomaslau</p>
                                                <p className="inbox-item-text">I've finished it! See you so...</p>
                                                <p className="inbox-item-date">13:34 PM</p>
                                            </div>
                                        </a>
                                        <a href="#">
                                            <div className="inbox-item">
                                                <div className="inbox-item-img"><img src="assets/images/users/avatar-3.jpg" className="rounded-circle bx-shadow-lg" alt="" /></div>
                                                <p className="inbox-item-author">Stillnotdavid</p>
                                                <p className="inbox-item-text">This theme is awesome!</p>
                                                <p className="inbox-item-date">13:17 PM</p>
                                            </div>
                                        </a>
                                        <a href="#">
                                            <div className="inbox-item">
                                                <div className="inbox-item-img"><img src="assets/images/users/avatar-4.jpg" className="rounded-circle bx-shadow-lg" alt="" /></div>
                                                <p className="inbox-item-author">Kurafire</p>
                                                <p className="inbox-item-text">Nice to meet you</p>
                                                <p className="inbox-item-date">12:20 PM</p>
                                            </div>
                                        </a>
                                        <a href="#">
                                            <div className="inbox-item">
                                                <div className="inbox-item-img"><img src="assets/images/users/avatar-5.jpg" className="rounded-circle bx-shadow-lg" alt="" /></div>
                                                <p className="inbox-item-author">Shahedk</p>
                                                <p className="inbox-item-text">Hey! there I'm available...</p>
                                                <p className="inbox-item-date">10:15 AM</p>
                                            </div>
                                        </a>
                                        <a href="#">
                                            <div className="inbox-item">
                                                <div className="inbox-item-img"><img src="assets/images/users/avatar-6.jpg" className="rounded-circle bx-shadow-lg" alt="" /></div>
                                                <p className="inbox-item-author">Adhamdannaway</p>
                                                <p className="inbox-item-text">This theme is awesome!</p>
                                                <p className="inbox-item-date">9:56 AM</p>
                                            </div>
                                        </a>
                                        <a href="#">
                                            <div className="inbox-item">
                                                <div className="inbox-item-img"><img src="assets/images/users/avatar-8.jpg" className="rounded-circle bx-shadow-lg" alt="" /></div>
                                                <p className="inbox-item-author">Arashasghari</p>
                                                <p className="inbox-item-text">Hey! there I'm available...</p>
                                                <p className="inbox-item-date">10:15 AM</p>
                                            </div>
                                        </a>
                                        <a href="#">
                                            <div className="inbox-item">
                                                <div className="inbox-item-img"><img src="assets/images/users/avatar-9.jpg" className="rounded-circle bx-shadow-lg" alt="" /></div>
                                                <p className="inbox-item-author">Joshaustin</p>
                                                <p className="inbox-item-text">I've finished it! See you so...</p>
                                                <p className="inbox-item-date">9:56 AM</p>
                                            </div>
                                        </a>
                                    </div>

                                </div>
                            </div> */}
                            {/* <div className="col-lg-4">
                                <div className="card-box">
                                    <h4 className="header-title mb-3">Latest Comments</h4>

                                    <div className="comment-list slimscroll">
                                        <a href="#">
                                            <div className="comment-box-item">
                                                <div className="badge badge-pill badge-success">Ubold - Admin</div>
                                                <p className="commnet-item-date">1 month ago</p>
                                                <h6 className="commnet-item-msg">Do you have any plans to add a vertical menu?</h6>
                                                <p className="commnet-item-user">Ubold User</p>
                                            </div>
                                        </a>
                                        <a href="#">
                                            <div className="comment-box-item">
                                                <div className="badge badge-pill badge-warning">Adminox - Admin</div>
                                                <p className="commnet-item-date">1 month ago</p>
                                                <h6 className="commnet-item-msg">Hello, what is your plan to upgrade Bootstrap 4 versions? Beta or wait for stable?</h6>
                                                <p className="commnet-item-user">Ubold User</p>
                                            </div>
                                        </a>
                                        <a href="#">
                                            <div className="comment-box-item">
                                                <div className="badge badge-pill badge-primary">Staro - Landing</div>
                                                <p className="commnet-item-date">1 month ago</p>
                                                <h6 className="commnet-item-msg">Hi coderthemes – do you have PSD for this admin UI? I could really use it.</h6>
                                                <p className="commnet-item-user">Ubold User</p>
                                            </div>
                                        </a>
                                        <a href="#">
                                            <div className="comment-box-item">
                                                <div className="badge badge-pill badge-dark">Ubold - Admin</div>
                                                <p className="commnet-item-date">1 month ago</p>
                                                <h6 className="commnet-item-msg">Do you have any plans to add a vertical menu?</h6>
                                                <p className="commnet-item-user">Ubold User</p>
                                            </div>
                                        </a>
                                    </div>

                                </div>
                            </div> */}
                            <div className="col-lg-4">
                                <div className="card-box" >
                                    <h4 className="header-title mb-3">Letest Message Utilization</h4>

                                    <ul className="list-unstyled transaction-list" >
                                        <UseMessages />
                                        {/* <li>
                                            <h1 className="badge badge-pill badge-success">Ubold - Admin</h1><br></br>
                                            <i className=""></i>
                                            <span className="tran-text">Support licence</span>
                                            <span className="float-right text-danger tran-price">left_message:-90</span>
                                            <span className="float-right text-muted">total_message:-500</span>
                                            <span className="clearfix"></span>
                                        </li>  */}

                                    </ul>

                                </div>
                            </div>

                            <div className="col-lg-4">
                                <div className="card-box">
                                    <h4 className="header-title mb-3">Letest Recharge Status</h4>

                                    <ul className="list-unstyled transaction-list " >
                                        <LastTransactionHistory />


                                        {/* <li>
                                            <i className="dripicons-arrow-up text-danger"></i>
                                            <span className="tran-text">Support licence</span>
                                            <span className="float-right text-danger tran-price">left_message:-90</span>
                                            <span className="float-right text-muted">total_message:-500</span>
                                            <span className="clearfix"></span>
                                        </li>  */}

                                    </ul>

                                </div>
                            </div>

                        </div>


                    </div>


                </div>

            </div>

        </>
    )
}


export default Home;